
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    elements: Array as PropType<Array<string>>,
    selectedIndex: {
      type: Number,
      default: 0,
    },
  },
});
